module.exports = __webpack_public_path__ + "media/public/images/slider/banner_mobile-8909bb6b1449ea58bf78d22bb2ceffae.png";